import { Progress } from '@alphabait/ui' // progress'
import { useTranslation } from 'react-i18next'
import { BaseQuestionRendererProps, CheckboxAnswer } from './types'
import { ChartWrapper, ChartEmptyState } from './shared'

export function CheckboxPercentBar({ question }: BaseQuestionRendererProps) {
  const { t } = useTranslation()
  const checkboxAnswers = question.answers.filter(
    (answer): answer is CheckboxAnswer =>
      typeof (answer as CheckboxAnswer).value === 'boolean',
  )

  const yesCount = checkboxAnswers.filter((answer) => answer.value).length
  const totalRespondents = question.totalRespondents || checkboxAnswers.length
  const yesPercentage =
    totalRespondents > 0 ? (yesCount / totalRespondents) * 100 : 0

  if (checkboxAnswers.length === 0) {
    return (
      <ChartWrapper
        title={question.label}
        description={t('dashboard.charts.yes_no_responses')}
      >
        <ChartEmptyState message={t('dashboard.charts.no_responses_yet')} />
      </ChartWrapper>
    )
  }

  return (
    <ChartWrapper
      title={question.label}
      description={t('dashboard.charts.respondents_selected_yes', {
        count: yesCount,
        total: totalRespondents,
      })}
    >
      <div className="space-y-4 w-full px-20">
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span>{t('dashboard.charts.yes')}</span>
            <span className="font-medium">{yesPercentage.toFixed(1)}%</span>
          </div>
          <Progress value={yesPercentage} />
        </div>

        <div className="grid grid-cols-2 gap-4 text-sm">
          <div className="text-center p-3 bg-green-50 rounded-lg">
            <div className="font-semibold text-gray-30">{yesCount}</div>
            <div className="text-gray-30">{t('dashboard.charts.yes')}</div>
          </div>
          <div className="text-center p-3 bg-gray-20 rounded-lg">
            <div className="font-semibold text-gray-30">
              {totalRespondents - yesCount}
            </div>
            <div className="text-gray-30">{t('dashboard.charts.no')}</div>
          </div>
        </div>

        <div className="text-xs text-muted-foreground text-center">
          {t('dashboard.charts.total_responses', { count: totalRespondents })}
        </div>
      </div>
    </ChartWrapper>
  )
}
